const palette =  {
  type: "light",
  primary: {
    main: "#3C4FB9",
    light: "#1967D2",
    dark: "#003C4D",
    25: "#F5F7FF"
  },
  secondary: {
    main: "#8592E0",
    light: '#0066ff',
    contrastText: '#ffcc00',
  },
  tertiary: {
      one: "#CAD1FB",
  },
  quaternary: {
      one: "#DCE7F8",  
  },
  neutral: {
      zero: "#F4F9FD",
      one: "#F1F7FB",
      two: "#E8F0F5",
      three: "#ECF1F4",
      six: "#7B8A9E"
  },
  gray: {
      half: "#E8EBF1",
      fifty: "#E8EBF1",
      ccc: "#8F9CAD",
      cc: "#AEB7C3",
      border: "#D9EAF5",
      600: "#56677B",
      500: "#64768C",
      700: "#465464",
      800:"#36414E",
      900: "#252D36",
      25: "#FAFCFF",
      1:"#EADDFF"
    },
  darkGray: {
      one: "#CACCCF",
      two: "#A7AEB7",
      twoHalf: "#9DA9B9",
      three: "#56677B",
      default: "#00314D"
  },
  other: {
    border: "#E6E1E5"
  },
  alert: {
      red: "#B14861",
      lightRed : "#F5E1E0"
  },
  warning : {
      main : "#D65A26"
  },
  text: {
    primary: "#003C4D",
    darkGray: "#00314D"
  },
};

export default palette;